import { X } from 'lucide-react'
import type { UserSettings } from '@fuelfinder/shared'
import { RadiusSelector } from './RadiusSelector'

interface SettingsModalProps {
  open: boolean
  onClose: () => void
  settings: UserSettings
  updateSettings: (partial: Partial<UserSettings>) => void
}

/**
 * Settings modal - changes apply immediately
 */
export function SettingsModal({ open, onClose, settings, updateSettings }: SettingsModalProps) {

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="relative bg-white dark:bg-slate-900 rounded-xl shadow-xl w-full max-w-md max-h-[85dvh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 z-10 bg-white dark:bg-slate-900 flex items-center justify-between p-4 border-b border-slate-200 dark:border-slate-700">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Settings
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 min-h-[44px] rounded-lg text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            aria-label="Close settings"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-6">
          {/* Search Radius Section */}
          <section>
            <label className="block text-sm text-slate-500 dark:text-slate-400 uppercase tracking-wide font-medium mb-2">
              Search Radius
            </label>
            <RadiusSelector
              value={settings.radiusMiles}
              onChange={(radiusMiles) => updateSettings({ radiusMiles })}
            />
          </section>
        </div>

        {/* Footer with close button */}
        <div className="p-4 border-t border-slate-200 dark:border-slate-700">
          <button
            onClick={onClose}
            className="w-full py-3 px-4 rounded-lg text-white bg-brand-500 hover:bg-brand-600 font-medium transition-colors"
          >
            Done
          </button>
        </div>

        {/* Version footer */}
        <div className="px-4 pb-4 text-center">
          <p className="text-xs text-slate-400 dark:text-slate-500">
            PowerMap v1.0
          </p>
        </div>
      </div>
    </div>
  )
}
